import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {greyishBlue600} from "assets/jss/main";

import {formatDate} from "views/personalShopper/components/formatters";

import SideCard from "./SideCard";

ContactCard.propTypes = {
    conversation: PropTypes.object.isRequired,
};

Row.propTypes = {
    labelId: PropTypes.string.isRequired,
    children: PropTypes.node,
};

function Row({labelId, children}) {
    return (
        <div style={{display: "flex", justifyContent: "space-between", gap: "12px", fontSize: "13px", padding: "3px 0"}}>
            <span style={{color: greyishBlue600, whiteSpace: "nowrap"}}><FormattedMessage id={labelId} /></span>
            <span style={{textAlign: "right", overflow: "hidden", textOverflow: "ellipsis"}}>{children}</span>
        </div>
    );
}

/**
 * How to reach the shopper and whether a site account is linked to the number.
 */
function ContactCard({conversation}) {
    return (
        <SideCard titleId="personalShopper.sheet.contact">
            <Row labelId="personalShopper.sheet.contact.phone"><a href={`https://wa.me/${conversation.waId}`} target="_blank" rel="noopener noreferrer">{conversation.phone}</a></Row>
            <Row labelId="personalShopper.sheet.contact.email">{conversation.email || "–"}</Row>
            <Row labelId="personalShopper.sheet.contact.account">
                <FormattedMessage id={conversation.customerId ? "personalShopper.sheet.contact.account.linked" : "personalShopper.sheet.contact.account.none"} />
            </Row>
            <Row labelId="personalShopper.sheet.contact.since">{formatDate(conversation.createdAt)}</Row>
            {conversation.language && <Row labelId="personalShopper.sheet.contact.language">{String(conversation.language).toUpperCase()}</Row>}
        </SideCard>
    );
}

export default ContactCard;
